import { useState, useEffect } from 'react'
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { Dialog } from 'primereact/dialog';
import { Button, Icon, Divider, Label } from 'semantic-ui-react';
import { SelectButton } from 'primereact/selectbutton';
import { Image } from 'primereact/image';
import KioskService from 'app/services/KioskService';
import messages, { FormattedMessage } from 'shared/messages/messages';

import {
    getKnockOutElements,
    selectPrintSizeForCrop
} from 'app/actions/kioskActions';

import {
    showCropMoment,
    showPrintSizeEdits
} from 'app/actions/photoSwipeActions'


const styles = () => ({
});

const PrintSizeDialog = (props) => {
    const { settings, cropMomentId, printSizes, getKnockOutElements,
        onClose, printSizeEditsVisible, showCropMoment, cropMoment, selectPrintSizeForCrop,
        cropMomentVisible, showPrintSizeEdits } = props;
    const [momentPrintSizes, setMomentPrintSizes] = useState([]);
    const [edits, setEdits] = useState([]);
    const [selectedPrintSize, setSelectedPrintSize] = useState(null);

    useEffect(() => {
        if (!cropMomentVisible) {
            getPrintSizes();
        }
    }, [cropMomentId, cropMomentVisible]);

    useEffect(() => {
        if (selectedPrintSize) {
            selectPrintSizeForCrop(selectedPrintSize.printSize);
        }
    }, [selectedPrintSize])

    useEffect(async () => {
        const _edits = [...edits];
        const noEditsSizes = [];
        for (var printSize of momentPrintSizes) {
            const elements = await getKnockOutElements(cropMomentId, printSize?.size);
            if (elements.has_edit) {
                _edits.push({ printSize, moment_url: elements.new_moment_url });
            } else {
                noEditsSizes.push(printSize)
            }

        }

        for (var printSize of noEditsSizes) {
            _edits.push({ printSize, moment_url: null });
        }

        setEdits(_edits);

    }, [momentPrintSizes])

    const getPrintSizes = () => {
        setEdits([]);
        if (cropMomentId > 0) {
            return KioskService.getMomentPrintSizes(settings.kiosk_id, cropMomentId).then((momentPrintSizes) => {
                let availablePrintSizes = [...printSizes];
                if (momentPrintSizes && momentPrintSizes.length > 0) {
                    availablePrintSizes = momentPrintSizes;
                }

                if (availablePrintSizes && availablePrintSizes.length > 0) {
                    setMomentPrintSizes(availablePrintSizes);
                }
            });
        }
    }

    const optionTemplate = (option) => {
        return <div>
            {
                option.moment_url ?
                    <div style={{ marginBottom: '35px' }}>
                        <Image src={option.moment_url + '&t=' + new Date().getTime()} height='80' />
                        <br />
                        <Label attached='bottom'>{option.printSize?.size}</Label>
                    </div> :
                    <div>
                        <div style={{ height: '56px', textAlign: 'center', marginBottom: '35px', paddingTop: '40%' }} >
                            <label><FormattedMessage {...messages.kiosk_print_size_edits_create} /></label>&nbsp;<Icon name="plus" />
                        </div>
                        <br />
                        <Label attached='bottom'>{option.printSize?.size}</Label>
                    </div>
            }
        </div>
    };

    const handleContinue = () => {
        if (selectedPrintSize) {
            showCropMoment(true, cropMoment);
        } else {
            window.alert('Please select a print size');
        }
    }

    const dialogFooter = () => {
        return <div>
            <Divider />
            <Button.Group>
                <Button onClick={onClose}><FormattedMessage {...messages.kiosk_print_size_edits_cancel} /></Button>
                <Button primary onClick={handleContinue}><FormattedMessage {...messages.kiosk_print_size_edits_continue} /></Button>
            </Button.Group>
        </div>
    }

    return <Dialog header="Print Size Edits"
        footer={dialogFooter}
        visible={printSizeEditsVisible}
        onHide={onClose} style={{ width: '60vw' }} >
        <Divider />
        <SelectButton value={selectedPrintSize} options={edits} itemTemplate={optionTemplate} onChange={e => setSelectedPrintSize(e.value)} />
    </Dialog>
}

const mapStateToProps = state => ({
    settings: state.kioskReducer.settings,
    user: state.kioskReducer.user,
    hasPrintSizeEdits: state.kioskReducer.hasPrintSizeEdits,
    cropMomentId: state.photoSwipeReducer.cropMomentId,
    printSizeEditsVisible: state.photoSwipeReducer.printSizeEditsVisible,
    cropMoment: state.photoSwipeReducer.cropMoment,
    cropMomentVisible: state.photoSwipeReducer.cropMomentVisible,
    printSizes: state.kioskReducer.printSizes,
});

export default connect(mapStateToProps, { getKnockOutElements, showCropMoment, selectPrintSizeForCrop, showPrintSizeEdits })(withStyles(styles)(PrintSizeDialog));